const convertStringSnakeCaseToCamelCase = (str: string): string => str.replace(/_([a-zA-Z])/g, (_, letter) => letter.toUpperCase());

const convertSnakeCaseToCamelCase = (input: any): any => {
  // Handle null, undefined, and primitive values
  if (input === null || input === undefined) {
    return input;
  }

  // Handle primitive types (string, number, boolean)
  if (typeof input !== 'object') {
    return input;
  }

  // Handle Date objects and other built-in objects that shouldn't be converted
  if (input instanceof Date || input instanceof RegExp || input instanceof Error) {
    return input;
  }

  // Handle arrays - recursively process each item
  if (Array.isArray(input)) {
    return input.map(item => convertSnakeCaseToCamelCase(item));
  }

  // Handle plain objects - convert keys and recursively process values
  if (input.constructor === Object || input.constructor === undefined) {
    const newObject: any = {};
    
    Object.keys(input).forEach((key) => {
      const camelKey = convertStringSnakeCaseToCamelCase(key);
      newObject[camelKey] = convertSnakeCaseToCamelCase(input[key]);
    });
    
    return newObject;
  }

  // For other object types (class instances, etc.), return as-is
  return input;
};

export default convertSnakeCaseToCamelCase;
